// extracted by mini-css-extract-plugin
module.exports = {"selectDiscount":"selectDiscount___X6Fyt","notUse":"notUse___3pY32","text":"text___kkIA7","icon":"icon___-ZnIB","disabledSplit":"disabledSplit___7Hdwt"};